import React from 'react';
import Navigation from '../../../components/Navigation/Navigation';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';
import OffersManager from '../../../components/OffersManager/OffersManager';
import Footer from '../../../components/Footer/Footer';

const OffersPage = () => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <OffersManager />
            <Footer />
        </div>
    );
};

export default OffersPage;